import React from 'react'
import { FormattedMessage } from 'react-intl'

import messages from '../i18n'
import { ModalDialogSeverityEnum } from '../redux/reducers/modalDialog/model'

export const NETWORK = {
  title: <FormattedMessage {...messages.errors.network.title} />,
  description: <FormattedMessage {...messages.errors.network.description} />,
  id: 'CENTRAL_ERROR_MODAL__NETWORK',
  severity: ModalDialogSeverityEnum.Error,
}

export const SERVER = {
  title: <FormattedMessage {...messages.errors.server.title} />,
  id: 'CENTRAL_ERROR_MODAL__SERVER',
  severity: ModalDialogSeverityEnum.Error,
}
export const SERVER_RETRY = {
  title: <FormattedMessage {...messages.errors.serverRetry.title} />,
  content: <FormattedMessage {...messages.errors.serverRetry.description} />,
  id: 'CENTRAL_ERROR_MODAL__SERVER_RETRY',
  severity: ModalDialogSeverityEnum.Error,
}

export const UNAUTHORIZED = {
  title: <FormattedMessage {...messages.errors.unauthorized.title} />,
  id: 'CENTRAL_ERROR_MODAL__UNAUTHORIZED',
  severity: ModalDialogSeverityEnum.Error,
}

export const TECHNICAL_DIFFICULTIES = {
  title: <FormattedMessage {...messages.errors.technicalDifficulties.title} />,
  content: <FormattedMessage {...messages.errors.technicalDifficulties.text} />,
  id: 'CENTRAL_ERROR_MODAL__TECHNICAL_DIFFICULTIES',
  severity: ModalDialogSeverityEnum.Error,
}
